import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login/login.vue'
import Navbar from '../views/Navbar/Navbar.vue'
import Inicio from '../views/Inicio/Inicio.vue'
import Administracion from '../views/Rutas/Administrador.vue'
import Cliente  from '../views/Rutas/Cliente.vue'
import RegistarNuevo from '../views/Rutas/ClienteNuevo.vue'
import NuevaConfiguracion from '../views/Configuracion/configuracion.vue'
import NuevoAcceso from '../views/Accesos/ConfiguracionAcceso.vue'
import Usuarios from '../views/CreacionUsuario/Usuario.vue'
import Reportes from '../views/Reporte/ReporteBI.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: "/Home",
    //  name: "Navbarse",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Navbar,
    meta: {
      autenticado: true,
    },

    children: [
      {
        path: "/",
        name: "inicio",
        component: Inicio,
      },
      {
        path: "/administrador",
        name: "REGISTRAR LINK BI",
        component: Administracion,
      },

      {
        path: "/cliente/:idCategoria",
        name: "DASHBOARD",
        component: Cliente,
      },

      {
        path: "/configuracion",
        name: "configuracion",
        component: NuevaConfiguracion,
      },


      
      {
        path: "/accesos",
        name: "accesos",
        component: NuevoAcceso,
      },


      {
        path: "/registrar",
        name: "registro",
        component: RegistarNuevo,
      },


      {
        path: "/Usuarios",
        name: "Usuarios",
        component: Usuarios,
      },

      {

        path: "/Reportes",
        name: "Reportes",
        component: Reportes,

      }


    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("access_token");
  // let entrada =localStorage.getItem("isSucces");
  let autenticado = to.matched.some((record) => record.meta.autenticado);

  if (autenticado && !token) {
    next("/");
  } else if (!autenticado && token) {
    next("/Home");
  } else {
    next();
  }
});

export default router
